import React, { useEffect, useState } from "react";
import { FiChevronDown, FiCheck, FiUsers, FiX } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const MobilePlanGroupPicker = ({
	groups,
	selectedGroupId,
	homeGroupId,
	onSelectGroup,
	allowSwitch,
}) => {
	const { t } = useTranslation();
	const [sheetOpen, setSheetOpen] = useState(false);

	const selected =
		groups.find((g) => g.id === selectedGroupId) || groups[0] || null;

	useEffect(() => {
		if (!sheetOpen) return undefined;
		const prev = document.body.style.overflow;
		document.body.style.overflow = "hidden";
		return () => {
			document.body.style.overflow = prev;
		};
	}, [sheetOpen]);

	if (!selected || groups.length === 0) return null;

	const memberLabel =
		selected.total_employees != null
			? t("plan.mobile.members", { count: selected.total_employees })
			: null;

	const openSheet = () => {
		if (allowSwitch) setSheetOpen(true);
	};

	const closeSheet = () => setSheetOpen(false);

	const handlePick = (id) => {
		onSelectGroup(id);
		closeSheet();
	};

	return (
		<div className="mobile-plan-group-picker">
			<button
				type="button"
				className={`mobile-plan-group-picker__trigger${allowSwitch ? "" : " mobile-plan-group-picker__trigger--static"}`}
				onClick={openSheet}
			>
				<div className="mobile-plan-group-picker__icon">
					<FiUsers size={18} color="#fff" />
				</div>
				<div className="mobile-plan-group-picker__text">
					<div className="mobile-plan-group-picker__title-row">
						<span className="mobile-plan-group-picker__name">
							{selected.name}
						</span>
						{homeGroupId != null && selected.id === homeGroupId && (
							<span className="mobile-plan-group-picker__badge">
								{t("plan.mobile.myGroup")}
							</span>
						)}
					</div>
					{memberLabel && (
						<span className="mobile-plan-group-picker__meta">
							{memberLabel}
						</span>
					)}
				</div>
				{allowSwitch && (
					<FiChevronDown
						className="mobile-plan-group-picker__chevron"
						size={22}
					/>
				)}
			</button>

			{sheetOpen && (
				<div
					className="mobile-plan-group-picker__backdrop"
					onClick={closeSheet}
					onKeyDown={(e) => e.key === "Escape" && closeSheet()}
					role="presentation"
				>
					<div
						className="mobile-plan-group-picker__sheet"
						onClick={(e) => e.stopPropagation()}
						role="dialog"
						aria-label={t("plan.mobile.changeGroup")}
					>
						<div className="mobile-plan-group-picker__sheet-head">
							<h3 className="mobile-plan-group-picker__sheet-title">
								{t("plan.mobile.changeGroup")}
							</h3>
							<button
								type="button"
								className="mobile-plan-group-picker__sheet-close"
								onClick={closeSheet}
								aria-label={t("common.close")}
							>
								<FiX size={22} />
							</button>
						</div>
						<div className="mobile-plan-group-picker__sheet-list">
							{groups.map((g) => {
								const isSelected = g.id === selectedGroupId;
								const isHome = homeGroupId != null && g.id === homeGroupId;
								const rowMembers =
									g.total_employees != null
										? t("plan.mobile.members", { count: g.total_employees })
										: null;
								return (
									<button
										key={g.id}
										type="button"
										className={`mobile-plan-group-picker__row${isSelected ? " mobile-plan-group-picker__row--selected" : ""}`}
										onClick={() => handlePick(g.id)}
									>
										<div className="mobile-plan-group-picker__icon mobile-plan-group-picker__icon--small">
											<FiUsers size={16} color="#fff" />
										</div>
										<div className="mobile-plan-group-picker__row-text">
											<div className="mobile-plan-group-picker__title-row">
												<span className="mobile-plan-group-picker__name">
													{g.name}
												</span>
												{isHome && (
													<span className="mobile-plan-group-picker__badge">
														{t("plan.mobile.myGroup")}
													</span>
												)}
											</div>
											{rowMembers && (
												<span className="mobile-plan-group-picker__meta">
													{rowMembers}
												</span>
											)}
										</div>
										{isSelected && (
											<span className="mobile-plan-group-picker__check">
												<FiCheck size={14} color="#fff" />
											</span>
										)}
									</button>
								);
							})}
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default MobilePlanGroupPicker;
